import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import PropTypes from "prop-types";
import Cookies from "universal-cookie";
import { useTranslation } from "react-i18next";
import { accountService } from "@/_services";
import { DrawerFooter, NavToolbar } from "@/_components";
// import { history } from "@/_helpers";
import { styled, useTheme } from "@mui/material/styles";
import Link from "@mui/material/Link";

// Nav Imports
import AppBar from "@mui/material/AppBar";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

// Icon Imports
import Dashboard from "@mui/icons-material/Dashboard";
import PermDeviceInformation from "@mui/icons-material/PermDeviceInformation";
import Help from "@mui/icons-material/Help";
import ExitToAppOutlinedIcon from "@mui/icons-material/ExitToAppOutlined";
import { styledSlots, resolveStyledSlots } from "../../_helpers/styledSlots";
import LifeSaferLogo from "@/_images/LSISA_Logo.png";
const StyledListItem = styled(ListItemButton)(({ theme }) =>
  styledSlots(
    resolveStyledSlots(
      () => ({
        root: {
          color: "#6b7c96",
          fontSize: 16,
          fontWeight: 600,
          minHeight: 45,
          margin: 0,
          "&:before, &:after": {
            top: 1,
            content: '" "',
            height: 43,
            position: "absolute",
          },
          "&:before": {
            left: 0,
            width: 8,
          },
          "&:after": {
            left: 0,
            height: 43,
          },
          "&:hover, &:focus": {
            background: "initial",
            color: "#1c355e",
            "&:before": {
              background: "#6b7c96",
            },
          },
        },
        selected: {
          "&.Mui-selected": {
            color: "#1c355e",
            background: "initial",
            "&:hover, &:focus": {
              background: "initial",
            },
            "&:after": {
              width: 8,
              background: "#76bc21",
            },
          },
        },
      }),
      theme,
    ),
  ),
);

const StyledLogo = styled("img")(() => ({
  width: 168,
  height: "auto",
}));

const drawerWidth = 240;
const componentStyles = (theme) => ({
  drawer: {
    [theme.breakpoints.up("md")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up("md")]: {
      width: `calc(100%-${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
    [theme.breakpoints.up("sm")]: {
      marginRight: theme.spacing(2),
    },
    [theme.breakpoints.down("sm")]: {
      marginRight: theme.spacing(1),
    },
  },
  // Necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  badgeColor: {
    backgroundColor: "#d1495b",
  },
  logo: {
    [theme.breakpoints.up("sm")]: {
      width: 168,
      height: 34,
    },
    [theme.breakpoints.down("sm")]: {
      width: 138,
      height: 28,
    },
  },
  drawerFooter: {
    flex: 1,
    textAlign: "center",
  },
});
const StyledRoot = styled("div")(({ theme }) => ({
  display: "contents",
  ...Object.entries(componentStyles(theme)).reduce(
    (acc, [className, style]) => ({
      ...acc,
      [`& .${className}, &.${className}`]: style,
    }),
    {},
  ),
}));
function Nav({ selectedNav, updateSelected, ...props }) {
  const theme = useTheme();
  const { window } = props;
  const cookies = new Cookies();
  const user = cookies.get("driveSaferUser");
  const [mobileOpen, setMobileOpen] = useState(false);
  const { t } = useTranslation();
  const updateSelectedNav = (index) => {
    updateSelected(index);
  };

  // only show nav when logged in
  if (
    user === undefined ||
    user.jwtToken === undefined ||
    user.jwtToken === null ||
    user.jwtToken.length < 20
  )
    return null;
  const ListItemsNew = (
    <>
      <StyledListItem
        component={RouterLink}
        to="/dashboard"
        selected={selectedNav === "/dashboard"}
        onClick={() => {
          setMobileOpen(false);
          updateSelectedNav("/dashboard");
        }}
      >
        <ListItemIcon
          style={{
            color: "#1c355e",
          }}
        >
          <Dashboard />
        </ListItemIcon>
        {t("navigation.dashboard")}
      </StyledListItem>
      <StyledListItem
        component={RouterLink}
        to="/resources"
        selected={selectedNav === "/resources"}
        onClick={() => {
          setMobileOpen(false);
          updateSelectedNav("/resources");
        }}
      >
        <ListItemIcon
          style={{
            color: "#1c355e",
          }}
        >
          <PermDeviceInformation />
        </ListItemIcon>
        {t("navigation.resources")}
      </StyledListItem>
      <StyledListItem
        component={RouterLink}
        to="/help"
        selected={selectedNav === "/help"}
        onClick={() => {
          setMobileOpen(false);
          updateSelectedNav("/help");
        }}
      >
        <ListItemIcon
          style={{
            color: "#1c355e",
          }}
        >
          <Help />
        </ListItemIcon>
        {t("navigation.help")}
      </StyledListItem>
      <StyledListItem
        component={RouterLink}
        to="/account/login"
        selected={selectedNav === "/logOut"}
        onClick={accountService.logout}
      >
        <ListItemIcon
          style={{
            color: "#1c355e",
          }}
        >
          <ExitToAppOutlinedIcon />
        </ListItemIcon>
        {t("navigation.logOut")}
      </StyledListItem>
    </>
  );
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const drawer = (
    <Grid
      container
      style={{
        flexGrow: 1,
        minHeight: 420,
      }}
      sx={{
        flexDirection: "column",
      }}
    >
      <Grid
        className={"toolbar"}
        style={{
          textAlign: "center",
        }}
      >
        <Link
          href={`https://www.lifesaferisa.com/`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <StyledLogo
            src={LifeSaferLogo}
            component={RouterLink}
            alt="LifeSafer"
            style={{
              marginTop: 15,
            }}
            // onClick={() => {
            //   setMobileOpen(false);
            //   history.replace("/dashboard");
            // }}
          />
        </Link>
        {/* <img
          className={"logo"}
          src={LifeSaferLogo}
          alt="LifeSafer"
          style={{
            marginTop: 15,
          }}
          onClick={() => {
            setMobileOpen(false);
            history.push("/dashboard");
          }}
        /> */}
      </Grid>
      <Grid>
        <List>{ListItemsNew}</List>
      </Grid>
      <Grid className={"drawerFooter"} sx={{ flex:1 }}>
        <Grid
          container
          style={{
            height: "100%",
          }}
          sx={{
            flexDirection: "column",
            justifyContent: "flex-end",
          }}
        >
          <Grid>
            <DrawerFooter />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
  const container =
    window !== undefined ? () => window().document.body : undefined;
  const invisible = true;
  return (
    <StyledRoot>
      <div>
        <AppBar
          position="fixed"
          className={"appBar"}
          style={{
            backgroundColor: "white",
          }}
          elevation={2}
        >
          <NavToolbar
            selectedNav={selectedNav}
            invisible={invisible}
            handleDrawerToggle={handleDrawerToggle}
            setMobileOpen={setMobileOpen}
            updateSelectedNav={updateSelectedNav}
          />
        </AppBar>
        <nav className={"drawer"} aria-label="drawer pages">
          <Box sx={{ display: { xs: "block", sm: "none" } }}>
            <Drawer
              container={container}
              variant="temporary"
              anchor={theme.direction === "rtl" ? "right" : "left"}
              open={mobileOpen}
              onClose={handleDrawerToggle}
              classes={{
                paper: "drawerPaper",
              }}
              ModalProps={{
                keepMounted: true, // Better performance on mobile devices
              }}
            >
              {drawer}
            </Drawer>
          </Box>
          <Box sx={{ display: { xs: "none", md: "block" } }}>
            <Drawer
              classes={{
                paper: "drawerPaper",
              }}
              variant="permanent"
              open
            >
              {drawer}
            </Drawer>
          </Box>
        </nav>
      </div>
    </StyledRoot>
  );
}
Nav.propTypes = {
  selectedNav: PropTypes.string,
  updateSelected: PropTypes.func.isRequired,
  window: PropTypes.object,
  documentNavVisible: PropTypes.bool,
};
export { Nav };
